import http, { noneTokenHttp } from "../utils/http";
import { toast } from "../utils/toast";

// 휴대폰 소유 인증번호 발송
export const postUsersCert = (data) => {
  return new Promise((resolve, reject) => {
    noneTokenHttp
      .post("/users/cert", data)
      .then((res) => {
        toast.success("인증번호가 발송되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 휴대폰 소유 검증
export const postUsersCertVerify = (data) => {
  return new Promise((resolve, reject) => {
    noneTokenHttp
      .post("/users/cert/verify", data)
      .then((res) => {
        toast.success("인증에 성공하였습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 이메일 소유 인증번호 발송
export const postUsersCertEmail = (data) => {
  return new Promise((resolve, reject) => {
    noneTokenHttp
      .post("/users/cert/email", data)
      .then((res) => {
        toast.success("인증번호가 발송되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 이메일 소유 검증
export const postUsersCertEmailVerify = (data) => {
  return new Promise((resolve, reject) => {
    noneTokenHttp
      .post("/users/cert/email/verify", data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 유저 정보 가져오기
export const getUsers = (userIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/users/${userIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 회원 정보 수정
export const putUsers = (userIdx, data) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/users/${userIdx}`, data)
      .then((res) => {
        toast.success("회원정보가 수정되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 회원 정보 수정 전 비밀번호 체크
export const postPasswordCheck = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/auth/password", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 회원가입
export const postSignUpUser = (body) => {
  return new Promise((resolve, reject) => {
    noneTokenHttp
      .post("/users", body)
      .then((res) => {
        toast.success("회원가입이 완료되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 아이디 중복여부 검사
export const getExistId = (id) => {
  return new Promise((resolve, reject) => {
    noneTokenHttp
      .get(`/users/exist/id?id=${id}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 핸드폰 중복여부 검사
export const getExistMobile = (mobile) => {
  return new Promise((resolve, reject) => {
    noneTokenHttp
      .get(`/users/exist/mobile?mobile=${mobile}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 아이디찾기
export const postForgotId = (body) => {
  return new Promise((resolve, reject) => {
    noneTokenHttp
      .post("/users/forgot/id", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 비밀번호 찾기
export const postForgotPassword = (body) => {
  return new Promise((resolve, reject) => {
    noneTokenHttp
      .post("/users/forgot/password", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 회원 탈퇴
export const deleteUser = (userIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/users/${userIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const changeMasterPassword = (params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/users/master-password/change`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};